import React from "react";
import { AUDIT_STEPS } from "../../content";

const scrollToForm = (e) => {
  e.preventDefault();
  const el = document.getElementById("lead-form");
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function AuditProcess() {
  return (
    <section
      id="comment-ca-marche"
      data-testid="audit-section"
      className="bg-white met-section"
    >
      <div className="met-container">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          {/* LEFT */}
          <div className="lg:col-span-5 lg:sticky lg:top-32">
            <div className="text-[#005870] text-xs md:text-sm font-bold tracking-[0.2em] uppercase mb-4">
              Méthode MET
            </div>
            <h2
              data-testid="audit-title"
              className="text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight text-[#1A2E2C] leading-[1.1] text-balance"
            >
              Comment <span className="text-[#005870]">ça marche</span>.
            </h2>
            <p className="mt-6 text-[#1A2E2C]/75 text-base md:text-lg font-medium leading-relaxed">
              {`L'audit est gratuit, réalisé par un expert humain, sans aucun engagement de votre part. On regarde votre contrat actuel en détail et on vous dit exactement où vous en êtes.`}
            </p>

            <button
              type="button"
              onClick={scrollToForm}
              data-testid="audit-cta-button"
              className="group mt-8 inline-flex items-center gap-2 bg-[#005870] hover:bg-[#003242] text-white font-bold px-7 py-4 rounded-full transition-colors duration-300"
            >
              Je lance mon audit gratuit
              <svg className="transition-transform group-hover:translate-x-1" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14M13 6l6 6-6 6"/>
              </svg>
            </button>
          </div>

          {/* RIGHT — steps */}
          <ol className="lg:col-span-7 flex flex-col gap-2">
            {AUDIT_STEPS.map((step, i) => (
              <li
                key={step.n}
                data-testid={`audit-step-${i}`}
                className="relative grid grid-cols-[auto_1fr] gap-6 md:gap-8 py-8 md:py-10 border-b border-[#1A2E2C]/10 last:border-b-0"
              >
                <div className="flex flex-col items-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-[#88d2e7]/30 text-[#005870] flex items-center justify-center font-black text-lg md:text-xl shrink-0">
                    {step.n}
                  </div>
                  {i < AUDIT_STEPS.length - 1 && (
                    <div className="flex-1 w-px bg-gradient-to-b from-[#88d2e7]/60 to-transparent mt-3 min-h-[40px]" />
                  )}
                </div>
                <div className="pt-2">
                  <h3 className="text-[#1A2E2C] font-bold text-xl md:text-2xl mb-3">
                    {step.title}
                  </h3>
                  <p className="text-[#1A2E2C]/70 text-base md:text-lg leading-relaxed font-medium">
                    {step.text}
                  </p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
